import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Modal } from 'antd';
// Local Deps
import './SolicitationsSearch.scss';
import SolicitationsSearchHOC from './SolicitationsSearchHOC';
import msgs from '../../config/messages';
import SendSolicitation from '../../components/Modals/sendSolicitations';
// Components
import Draggable from '../../components/DraggableEntity';

import Loading from '../../components/Loading/Loading';
import SolicitationsGrid from '../../components/grids/SolicitationsGrid';
import SolicitationsSearchBar from '../../components/SolicitationsSearchBar';
import HorizontalScroll from '../../components/horizontalScroll';
import IHelpButton from '../../components/primitives/IHelpButton';


class SolicitationsSearch extends React.PureComponent {
  static propTypes = {
    solicitations: PropTypes.array.isRequired,
    meta: PropTypes.shape({
      hits: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      from: PropTypes.number.isRequired,
    }).isRequired,
    bidMatchingSettings: PropTypes.object.isRequired,
    onSearchButtonClick: PropTypes.func.isRequired,
    onSearchInputKeyDown: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onSearchInputChange: PropTypes.func.isRequired,
    searchText: PropTypes.string,
    isLoading: PropTypes.bool,
    downloadSelected: PropTypes.func.isRequired,
    onSortClick: PropTypes.func.isRequired,
    direction: PropTypes.string.isRequired,
    sortHeader: PropTypes.string.isRequired,
    folderized: PropTypes.array.isRequired,
    flagged: PropTypes.func.isRequired,
    tabChanged: PropTypes.func.isRequired,
    getSelectedSolicitations: PropTypes.func.isRequired,
    selectedSolicitations: PropTypes.array.isRequired,
    moveSolicitations: PropTypes.func.isRequired,
    changeSelection: PropTypes.func.isRequired,
    closePopUp: PropTypes.func.isRequired,
    selectAll: PropTypes.number.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    rawSelected: PropTypes.object.isRequired,
    selectedTab: PropTypes.string.isRequired,
    solicitationsToSend: PropTypes.object.isRequired,
    organizationsCage: PropTypes.string.isRequired,
    userRole: PropTypes.string.isRequired,
    organizationsName: PropTypes.string.isRequired,
    usersName: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
    statusAggs: PropTypes.object.isRequired,
    folderAggs: PropTypes.object.isRequired,
    auth: PropTypes.shape({
      role: PropTypes.string,
      jwtToken: PropTypes.string,
    }),

  };

  static defaultProps = {
    isLoading: false,
    searchText: '',
    auth: { role: 'COMMON_USER' },

  };
  static _formatSolicitation(solicitations) {
    return solicitations.map(solicitation => ({
      ...solicitation,
      value: `$${solicitation.estValue.replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
    }));
  }

  render() {
    const {
      solicitations,
      meta,
      direction,
      sortHeader,
      statusAggs,
      folderAggs,
      isLoading,
      onSearchButtonClick,
      onSearchInputKeyDown,
      onPageChange,
      onPageSizeChange,
      onSearchInputChange,
      searchText,
      auth,
      bidMatchingSettings,
      onSortClick,
      downloadSelected,
      folderized,
      flagged,
      tabChanged,
      getSelectedSolicitations,
      selectedSolicitations,
      moveSolicitations,
      changeSelection,
      closePopUp,
      selectAll,
      changeSelectAllValue,
      rawSelected,
      selectedTab,
      solicitationsToSend,
      organizationsCage,
      userRole,
      organizationsName,
      usersName,
      closeModal,
    } = this.props;
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Solicitations Search Page</title>
        </Helmet>

        <div className="nf-solicitations-search">
          <IHelpButton />

          {/* <!-- SEARCH BAR --> */}
          <SolicitationsSearchBar
            {...{
              selectedTab,
              meta,
              onSearchButtonClick,
              onSearchInputKeyDown,
              onSearchInputChange,
              isLoading,
              searchText,
              bidMatchingSettings,
              tabChanged,
              statusAggs,
              folderAggs,
              organizationsCage,
              auth,
            }}
          />
          {/* <!-- MAIN CONTENT + WRAPPER FOR STYLING QUIRKS WITH HEIGHT --> */}
          <div className="nf-solicitations-search__main-wrapper">
            <div className="nf-solicitations-search__main">
              {/* <!-- SIDE PANEL --> */}
              {/* <Drawer placement="left" visible height="100"> */}

              {/* </Drawer> */}
              {/* <!-- MAIN CONTENT --> */}
              <div className="nf-solicitations-search__content">
                {/* <!-- GRID --> */}
                {isLoading ? (
                  <Loading text={msgs.SolicitationsSearch.loading} />
                ) : (
                  <div className="nf-solicitations-search__grid">
                    <HorizontalScroll>
                      {' '}
                      <SolicitationsGrid
                        selectedTab={selectedTab}
                        organizationsCage={organizationsCage}
                        userRole={userRole}
                        folderized={folderized}
                        downloadSelected={downloadSelected}
                        solicitations={SolicitationsSearch._formatSolicitation(
                          solicitations,
                        )}
                        page={meta.from / meta.size}
                        pageSize={meta.size}
                        pageCount={Math.ceil(meta.hits / meta.size)}
                        onPageChange={onPageChange}
                        onPageSizeChange={onPageSizeChange}
                        onSortClick={onSortClick}
                        direction={direction}
                        sortHeader={sortHeader}
                        flagged={flagged}
                        getSelectedSolicitations={getSelectedSolicitations}
                        selectAll={selectAll}
                        changeSelectAllValue={changeSelectAllValue}
                        rawSelected={rawSelected}
                      />
                    </HorizontalScroll>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
        {selectedSolicitations.length > 0 && (
          <Draggable
            changeSelection={changeSelection}
            moveSolicitations={moveSolicitations}
            selected={selectedSolicitations.length}
            closePopUp={closePopUp}
            selectedTab={selectedTab}
          />
        )}
        <Modal
          title="Send Solicitations to Suppliers"
          visible={!!Object.keys(solicitationsToSend).length}
          width="80%"
          footer={[]}
          // onOk={this.handleOk}
          destroyOnClose
          onCancel={closeModal}
        >
          <SendSolicitation
            solicitationsToSend={solicitationsToSend}
            organizationsCage={organizationsCage}
            userRole={userRole}
            organizationsName={organizationsName}
            usersName={usersName}
            closeModal={closeModal}
          />
        </Modal>
      </div>
    );
  }
}

export default SolicitationsSearchHOC(SolicitationsSearch);



// WEBPACK FOOTER //
// ./src/pages/SolicitationsSearch/SolicitationsSearch.jsx